import React from 'react';

export interface RoleTemplateProps {
  role?: string;
  children: React.ReactNode;
  allow?: () => boolean;
}

const RoleTemplate: React.FC<RoleTemplateProps> = ({ children }) => {
  return <>{children}</>;
};

export default RoleTemplate;
